import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const initDemoDateTimePickers = () => {
    const dateInput = document.querySelector("#preferredDate");
    const timeInput = document.querySelector("#preferredTime");

    if (!dateInput || !timeInput) {

        return;
    }

    let selectedDate = null;


    flatpickr(dateInput, {
        altInput: true,
        allowInput: false,
        dateFormat: "F d, Y",
        minDate: "today",
        disableMobile: true,
        disable: [
            (date) => date.getDay() === 0 || date.getDay() === 6
        ],
        onChange(selectedDates) {
            selectedDate = selectedDates.length
                ? selectedDates[0]
                : null;
            updateTimeLimits();
        }
    });

    const timePicker = flatpickr(timeInput, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "h:i K",
        altInput: false,
        minuteIncrement: 30,
        time_24hr: false,
        minTime: "09:00",
        maxTime: "17:00",
        allowInput: false,
        disableMobile: true
    });

    function updateTimeLimits() {
        if (!selectedDate) {
            timePicker.set("minTime", "09:00");
            timePicker.set("maxTime", "17:00");
            return;
        }

        const now = new Date();

        const isToday =
            selectedDate.getFullYear() === now.getFullYear() &&
            selectedDate.getMonth() === now.getMonth() &&
            selectedDate.getDate() === now.getDate();

        if (!isToday) {
            timePicker.set("minTime", "09:00");
            timePicker.set("maxTime", "17:00");
            return;
        }

        const nextSlot = new Date(now);

        nextSlot.setMinutes(
            Math.ceil(nextSlot.getMinutes() / 30) * 30,
            0,
            0
        );

        if (nextSlot.getHours() < 9) {
            nextSlot.setHours(9, 0, 0, 0);
        }

        if (nextSlot.getHours() >= 17) {
            timePicker.clear();
            timePicker.input.disabled = true;
            return;
        }

        timePicker.input.disabled = false;

        timePicker.set(
            "minTime",
            `${String(nextSlot.getHours()).padStart(2, "0")}:${String(nextSlot.getMinutes()).padStart(2, "0")}`
        );

        timePicker.set("maxTime", "17:00");
    }
};

if (document.readyState === "loading") {
    document.addEventListener(
        "DOMContentLoaded",
        initDemoDateTimePickers
    );
} else {
    initDemoDateTimePickers();
}